import axios from 'axios';
import { IFormData, INewProduct, IProductFull } from '../Utils/types';

const instance = axios.create({
  baseURL: 'https://shoop-backend.herokuapp.com',
  withCredentials: true
});

export const userApi = {

};
export const shopApi = {
  async getAllOrders(page: number, pageSize: number) {
    return instance.get(`/admin/orders/${page}/${pageSize}`).then((value) => {
      return value.data
    });
  },
  async getOrder(id: number) {
    return instance.get(`/admin/order/${id}`).then((value) => {
      return value.data
    });
  },
  async removeOrder(id: number) {
    return instance.delete(`/admin/order/${id}`).then((value) => {
      return value.data
    });
  },
  async getCategories() {
    return instance.get(`/categories`).then((value) => {
      return value.data
    });
  },
  async newCategory(name: string) {
    return instance.post(`/admin/category`, { name }).then((value) => {
      return value.data
    });
  },
  async removeCategory(id: number) {
    return instance.delete(`/admin/category/${id}`).then((value) => {
      return value.data
    });
  },
  async patchCategory(name: string, id: number) {
    return instance.patch(`/admin/category`, { name, id }).then((value) => {
      return value.data
    });
  },
  async uploadPhoto(file: any, id: number, mod?: boolean) {
    const formData = new FormData();
    formData.append('image', file);
    formData.append('id', '' + id);
    if (mod) {
      formData.append('mod', '' + mod);
    }

    return instance.post(`/admin/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then((value) => {
      return value.data
    });
  },
  async newProduct(data: INewProduct) {
    return instance.post(`/admin/product`, data).then((value) => {
      return value.data
    });
  },
  async getProducts(page: number, pageSize: number) {
    return instance.get(`/products/${page}/${pageSize}`).then((value) => {
      return value.data
    });
  },
  async getProduct(id: number) {
    return instance.get(`/product/${id}`).then((value) => {
      return value.data
    });
  },
  async applyUpdateProduct(data: IProductFull) {
    return instance.patch(`/admin/product`, data).then((value) => {
      return value.data
    });
  },
  async removeProduct(id: number) {
    return instance.delete(`/admin/product/${id}`).then((value) => {
      return value.data
    });
  },
  async ordersChart() {
    return instance.get(`/admin/ordersChart`).then((value) => {
      return value.data
    });
  },
  async changeOrderStatus(id: number, status: number) {
    return instance.patch(`/admin/order`, { id, status }).then((value) => {
      return value.data
    });
  },
}
export const authApi = {
  async isLogined() {
    return instance.get(`/isloggedin`).then((value) => {
      return value.data.logined
    });
  },
  async login(formData: IFormData) {
    return instance.post(`/login`, formData).then((response) => {
      return response.data
    });
  },
  async logOut() {
    return instance.delete(`/logout`);
  }
}

export const adminApi = {
  async getProfile() {
    return instance.get(`/admin/profile`).then((response) => {
      return response.data
    });
  },
  async getAdmins() {
    return instance.get(`/admin/all`).then((value) => {
      return value.data
    });
  },
  async removeAdmin(id: number) {
    return instance.delete(`/admin/profile/${id}`).then((value) => {
      return value.data
    });
  },
  async addAdmin(form: {id: number, level: number, email: string}) {
    return instance.post(`/admin/add`, form).then((value) => {
      return value.data
    });
  },
  async updateLevelAdmin(id: number, level: number) {
    return instance.patch(`/admin/level`, { id, level }).then((value) => {
      return value.data
    });
  },
}